import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControl } from '@angular/forms';
import { minuteList, hourList, dayList, weekdayList, monthList } from './interval-data';

declare var jQuery: any;

@Component({
  selector: 'itpx-interval',
  templateUrl: './interval.component.html',
  styleUrls: ['./interval.component.css'],
  providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IntervalComponent),
            multi: true
        }
    ]
})
export class IntervalComponent implements OnInit, ControlValueAccessor {

  @Input('value') _value: any;
  @Input() cronDecoder: boolean;
  propagateChange = (_:any) => {};
  form: FormGroup;

  private disableSearch = 80;
  private cronDecodedMessage: string;
  private minutes: string;
  private hours: string;
  private daysOfMonth: string;
  private months: string;
  private weekdays: string;

  private minuteList = minuteList;
  private hourList = hourList;
  private dayList = dayList;
  private monthList = monthList;
  private weekdayList = weekdayList;

  constructor() { }

  ngOnInit() {
    
    if(this._value) {
      let interval = this._value.split(' ');
      this.minutes = interval[0];
      this.hours = interval[1];
      this.daysOfMonth = interval[2];
      this.months = interval[3];
      this.weekdays = interval[4];

      this.form = new FormGroup({
        minute: new FormControl(this.minutes),
        hour: new FormControl(this.hours),
        dayOfMonth: new FormControl(this.daysOfMonth),
        month: new FormControl(this.months),
        weekday: new FormControl(this.weekdays),
      });

      if (this.cronDecoder) { 
        let intervalDtoList = [
          { key: this.minuteList,
            value: this.minutes,
            label: 'minute'
          }, 
          { key: this.hourList,
            value: this.hours,
            label: 'hour'
          },
          { key: this.dayList,
            value: this.daysOfMonth,
            label: 'dayOfMonth'
          },
          { key: this.monthList,
            value: this.months,
            label: 'month'
          },
          { key: this.weekdayList,
            value: this.weekdays,
            label: 'weekday'
          }];
        
        let cronDecoded = {};
        intervalDtoList.forEach(dto => {
          dto['key'].forEach( el => {
            if ( el['key'] == dto['value']) { 
              cronDecoded[dto['label']] = el['value'];
            }
          })
        });
        if (cronDecoded['dayOfMonth'].indexOf('Every') == 0) {
           this.cronDecodedMessage = ( 'At ' + cronDecoded['minute'] + ' past ' + cronDecoded['hour'] 
            + ' on  ' + cronDecoded['dayOfMonth'] + ' and on ' + cronDecoded['weekday'] + ' in '+ cronDecoded['month']);
        } else {
          this.cronDecodedMessage = ( 'At ' + cronDecoded['minute'] + ' past ' + cronDecoded['hour'] 
            + ' on day-of-month ' + cronDecoded['dayOfMonth'] + ' and on ' + cronDecoded['weekday'] + ' in '+ cronDecoded['month']);
        }
      }
        
    } else {
      this.form = new FormGroup({
        minute: new FormControl(),
        hour: new FormControl(),
        dayOfMonth: new FormControl(),
        month: new FormControl(),
        weekday: new FormControl(),
      });
    }
  }
  ngAfterViewInit() {
    if (this.daysOfMonth == '*' || this.daysOfMonth == '*/5' || this.daysOfMonth =='*/10' || this.daysOfMonth == '*/14' ) {
        jQuery('#dayOfMonth').addClass('hidden');
    };
  }

  get value() {
      return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(this._value);
  }

  writeValue(value: any) {
    this._value  = value;
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {

  }

  onChange() {
    let minutes = this.form.value.minute || '0';
    let hours = this.form.value.hour || '0';
    let days = this.form.value.dayOfMonth || '*';
    let months = this.form.value.month || '*';
    let weekdays = this.form.value.weekday || '*';

    this.value = [minutes, hours, days, months, weekdays].join(' ');
  }

  private onDayOfMonthChange(event : any) {
    if (event == '*' || event == '*/5' || event =='*/10' || event == '*/14' ) {
      jQuery('#dayOfMonth').addClass('hidden');
    } else {
      jQuery('#dayOfMonth').removeClass('hidden');
    }
    this.onChange();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/interval/interval.component.ts